import React, { useMemo } from "react";
import styled from "styled-components";
import { Row, theme } from "uikit";

import Parking from "../../../../../../../services/Parking2";
import { CellContentRoot } from "../../../../../../LightTable";
import { ExecutorInfo } from "../../../../../../common";

const StyledCellExecutor = styled(Row)<{
	active: boolean;
	background?: string;
}>`
	padding: 3px 6px;
	color: ${(props) => (props.active ? props.color : "lightgray")} !important;
	background: ${(props) => props?.background || "transparent"};
	width: 100%;
	display: flex;
	gap: 3px;
	font-size: 12px;
	white-space: wrap;
	align-items: flex-start;
	z-index: 1000;

	${theme.longWord}
`;

const StyledExecutorShortName = styled("div")<{
	useBgColor: boolean;
	useTextColor: boolean;
	bgColor: string;
	textColor: string;
}>`
	padding: 2px;
	height: 20px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	font-size: 11px;
	color: ${(props) =>
		props.useTextColor ? props.textColor : theme.colors.primary};
	background-color: ${(props) =>
		props.useBgColor ? props.bgColor : "transparent"};
	border-radius: 2px;
`;

const ShortName = ({ data }) => {
	const actualExecutorJournal = data?.executorShiftJournals?.find(
		(journal) => journal?.isLatest,
	)?.car?.class;

	const textColor = actualExecutorJournal?.textColor;
	const backgroundColor = actualExecutorJournal?.backgroundColor;

	const textColorHex = `${textColor?.model}(${textColor?.color?.join(",")})`;
	const backgroundColorHex = `${
		backgroundColor?.model
	}(${backgroundColor?.color?.join(",")})`;

	const carClassData = {
		shortName: actualExecutorJournal?.shortName || "",
		backgroundColor: backgroundColorHex,
		textColor: textColorHex,
		useBackgroundColor: actualExecutorJournal?.useBackgroundColor,
		useTextColor: actualExecutorJournal?.useTextColor,
	};

	return carClassData.shortName.length ? (
		<StyledExecutorShortName
			bgColor={carClassData.backgroundColor}
			textColor={carClassData.textColor}
			useBgColor={carClassData.useBackgroundColor}
			useTextColor={carClassData.useTextColor}
		>
			{carClassData.shortName}
		</StyledExecutorShortName>
	) : (
		<div style={{ height: 0, width: 0, position: "absolute" }}></div>
	);
};

const AliasesCellContent: React.FC<AliasesCellContent.Props> = ({ item }) => {
	const content: any[] = useMemo(
		() => item.executorsQueue ?? [],
		[item.executorsQueue],
	);

	return (
		<CellContentRoot
			alignItems="center"
			w="100%"
			h="100%"
			p="0"
			cursor="pointer"
		>
			<StyledCellExecutor active={item?.active} wrap="wrap">
				{content?.length ? (
					content.map((queue, index) => (
						<Row
							key={queue?.executor?.id || index}
							align="center"
							gaps="2px"
						>
							<ExecutorInfo
								widgetType="Parking"
								id={queue?.executor?.id}
								speed={queue?.executor?.location?.speed}
							/>
							<ShortName data={queue?.executor} />
						</Row>
					))
				) : (
					<div style={{ height: 26 }}></div>
				)}
			</StyledCellExecutor>
		</CellContentRoot>
	);
};

declare namespace AliasesCellContent {
	interface Props {
		item: Parking.Model;
	}
}

export default AliasesCellContent;
